module.exports = __webpack_public_path__ + "media/reskin-images/icon--check-77f4c4b7.svg";